import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import type { StepData } from '../../../types/blog';

interface StepProps {
  data: StepData;
}

const Step: React.FC<StepProps> = ({ data }) => {
  const steps = data.steps ?? [];

  return (
    <ol className="space-y-6 list-none m-0 p-0">
      {steps.map((step, i) => (
        <li key={i} className="flex gap-4">
          <div
            className="shrink-0 w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm text-white mt-0.5"
            style={{ background: 'var(--vscode-primary)' }}
          >
            {i + 1}
          </div>
          <div className="flex-1 min-w-0">
            {step.title && (
              <p className="font-semibold vscode-text-primary text-base mb-1">{step.title}</p>
            )}
            {step.description && (
              <div className="vscode-text-secondary text-sm leading-relaxed prose prose-sm max-w-none dark:prose-invert">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{step.description}</ReactMarkdown>
              </div>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
};

export default Step;
